<template>
  <div class="layer waitingcallEdit">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"><span class="blind">close</span></button>
      <h2 class="layerTitle toCapitalize">{{detailInfo.name}} > {{locale[`waitingcall_${detailInfo.template}`]}}</h2>
      <!-- 타이틀, 상세 -->
      <div
        v-for="(item, index) in contentData"
        :key="index"
        class="mb15">
        <p class="mb5 setLabel innerTitle toCapitalize">{{locale[item]}}</p>
        <div class="translation">
          <!-- <input
            v-if="isMessage(item)"
            v-model="content[item][lang.default]"
            type="text" class="input"
            @focusout="setDefaultVal(item)"> -->
          <textarea
            class="input"
            :rows="isLongDesc(item) ? 8 : 2"
            v-model="content[item][lang.default]"
            @focusout="setDefaultVal(item)"></textarea>
          <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click.stop="onLangValueOpen(item)">
            <span class="blind">{{locale.language_specific_set}}</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
          </button>
        </div>
      </div>
      <p v-if="detailInfo.template === 'status'" class="infoMessage mb30 ">{var}: 대기인원 / {callStart}: 예상 호출시간 / {callEnd}: 예상 처리완료시간 / {spaceCodeName}: 대기 공간 이름</p>
      <!-- //타이틀, 상세 -->



      <!-- 내외국인 등록정보 -->
      <div v-if="detailData?.domestic && detailData?.foreign" class="mt30 mb30">
        <div class="flexBox">
          <!-- 내국인 등록정보 -->
          <div v-if="detailData && detailData.domestic" class="flexInner">
            <div class="mb5 setLabel innerTitle toCapitalize">
              내국인 등록 정보
            </div>
            <div class="mb15">
              <span class="colorGrey">기본 언어</span>
              <select class="input select" v-model="content.domesticLang">
                <option
                  v-for="item in langList"
                  :key="item.c"
                  :value="item.c">
                  {{ item.n }}
                </option>
              </select>
            </div>
            <div class="infoList">
              <p class="colorGrey">기본 등록 정보</p>
              <div class="infoGroup mb15">
                <div class="checkbox">
                  <input type="checkbox" name="domestic_info" id="domestic_info_phone" value="phone" :disabled="isDisabledInfo('domestic', 'phone')" v-model="content.domestic">
                  <label for="domestic_info_phone">{{ locale.tel }}</label>
                </div>
                <div class="checkbox">
                  <input type="checkbox" name="domestic_info" id="domestic_info_email" value="email" :disabled="isDisabledInfo('domestic', 'email')" v-model="content.domestic">
                  <label for="domestic_info_email">{{ locale.email }}</label>
                </div>
              </div>
              <div
                v-if="content.customFields?.length > 0"
                class="mt15">
                <p class="colorGrey">추가 등록 정보</p>
                <div class="infoGroup">
                  <div v-for="field in content.customFields" :key="field.id" class="checkbox">
                    <input type="checkbox" name="domestic_info" :id="`domestic_info_${field.id}`" :value="field.id" :disabled="isDisabledInfo('domestic', field.id)" v-model="content.domestic">
                    <label :for="`domestic_info_${field.id}`">{{ field.label[currentLanguage] }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- //내국인 등록정보 -->
          <!-- 외국인 등록정보 -->
          <div v-if="detailData && detailData.foreign" class="flexInner">
            <div class="mb5 setLabel innerTitle toCapitalize">
              외국인 등록 정보
            </div>
            <div class="mb15">
              <span class="colorGrey">기본 언어</span>
              <select class="input select" v-model="content.foreignLang">
                <option
                  v-for="item in langList"
                  :key="item.c"
                  :value="item.c">
                  {{ item.n }}
                </option>
              </select>
            </div>
            <div class="infoList">
              <p class="colorGrey">기본 등록 정보</p>
              <div class="infoGroup mb15">
                <div class="checkbox">
                  <input type="checkbox" name="foreign_info" id="foreign_info_phone" value="phone" :disabled="isDisabledInfo('foreign', 'phone')" v-model="content.foreign">
                  <label for="foreign_info_phone">{{ locale.tel }}</label>
                </div>
                <div class="checkbox">
                  <input type="checkbox" name="foreign_info" id="foreign_info_email" value="email" :disabled="isDisabledInfo('foreign', 'email')" v-model="content.foreign">
                  <label for="foreign_info_email">{{ locale.email }}</label>
                </div>
              </div>
              <div
                v-if="content.customFields?.length > 0"
                class="mt15">
                <p class="colorGrey">추가 등록 정보</p>
                <div class="infoGroup">
                  <div v-for="field in content.customFields" :key="field.id" class="checkbox">
                    <input type="checkbox" name="foreign_info" :id="`foreign_info_${field.id}`" :value="field.id" :disabled="isDisabledInfo('foreign', field.id)" v-model="content.foreign">
                    <label :for="`foreign_info_${field.id}`">{{ field.label[currentLanguage] }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- //외국인 등록정보 -->
        </div>
        <div class="mt30">
          <button type="button" class="btn btnWhite toCapitalize" @click="onAddInfoOpen">+ {{locale.manage_registration_info}}</button>
        </div>
      </div>
      <!-- //내외국인 등록정보 -->



      <!-- spaceCode 설정 -->
      <div v-if="detailInfo.template === 'setting'">
        <div class="checkbox">
          <input type="checkbox" id="set_entrance" v-model="content.entranceActive">
          <label for="set_entrance">시작 페이지 설정</label>
        </div>
        <div class="mt15 mb30">
          <SetLink
            v-if="content.entranceActive"
            :link="content.entranceUrl"
            :fix="['page']" />
        </div>
      </div>
      <!-- //spaceCode 설정 -->
      <div class="btns mt30">
      <button type="button" class="btn btnFull btnPrimary toCapitalize" @click="apply">{{locale.save}}</button>
      </div>
    </div>
    <!-- 언어별 세팅 -->
    <LangValue v-show="langValueLayer"
      :locale="locale"
      :textarea="true"
      :langValue="langValue"
      :title="locale.language_specific_set"
      @close="onLangValueClose" />
    <!-- //언어별 세팅 -->
    <!-- 등록정보 추가 -->
    <AddInfo v-if="addInfoLayer"
      :locale="locale"
      :lang="lang"
      :initialFields="content.customFields"
      @save="onAddInfoSave"
      @close="onAddInfoClose" />
    <!-- //등록정보 추가 -->
  </div>
</template>

<script>
import SetLink from '@/components/Util/SetLink'
import LangValue from '@/components/Util/LangValue.vue'
import AddInfo from '@/components/Waitingcall/AddInfo.vue'
import UTIL from '@/common/util'

export default {
  name: 'WaitingcallDetail',
  props: [
    'locale',
    'lang',
    'detailInfo',
    'detailData'
  ],
  components: {
    SetLink,
    LangValue,
    AddInfo
  },
  computed: {
    contentData () {
      const content = this.detailData && Object.keys(this.detailData)
      const reg = /domestic|foreign|entrance|customFields/
      return content && content.filter(x => !reg.test(x))
    },
    langList () {
      const langSetting = this.$store.getters['setting/getData']
      const list = langSetting && langSetting.lang && langSetting.lang.info
      const usableLang = langSetting && langSetting.lang && langSetting.lang.usable
      return list && list.filter(x => usableLang.includes(x.c))
    },
    currentLanguage() {
        return this.$store.state.service.locale.default;
      },
  },
  data () {
    let content = this._.cloneDeep(this.detailData)
    if (!content.customFields) content.customFields = []
    return {
      content,
      currentContent: null,
      langValueLayer: false,
      langValue: {},
      addInfoLayer: false
    }
  },
  methods: {
    isMessage (template) {
      return template.includes('message')
    },
    isLongDesc (template) {
      return this.detailInfo.template === 'tnc' && template === 'desc'
    },
    setDefaultVal (target) {
      const defaultLang = this.lang.default
      const fillLangs = UTIL.fillLangs(this.content[target], this.content[target][defaultLang])
      this.content[target] = fillLangs
    },
    onLangValueOpen (target) {
      this.langValueLayer = true
      this.currentContent = target
      this.langValue = this.content[target]
      // this.setDefaultVal(target)
    },
    onLangValueClose () {
      const target = this.currentContent
      this.langValueLayer = false
      this.content[target] = this.langValue
      this.langValue = {}
    },
    onAddInfoOpen () {
      this.addInfoLayer = true
    },
    onAddInfoSave (fields) {
      this.content.customFields = fields 
      this.addInfoLayer = false

      // 등록된 customFields 삭제 시, domestic, foreign에서 기존 사용중이던 customFields 제외
      const currentCustomFieldIds = this.content.customFields.map(field => field.id);

      if (this.content.domestic && Array.isArray(this.content.domestic)) {
        this.content.domestic = this.content.domestic.filter(id => {
          if (!String(id).startsWith('custom_')) {
            return true;
          }
          return currentCustomFieldIds.includes(id);
        });
      } else {
        this.content.domestic = [];
      }

      if (this.content.foreign && Array.isArray(this.content.foreign)) {
        this.content.foreign = this.content.foreign.filter(id => {
          if (!String(id).startsWith('custom_')) {
            return true;
          }
          return currentCustomFieldIds.includes(id);
        });
      } else {
        this.content.foreign = [];
      }
    },
    onAddInfoClose () {
      this.addInfoLayer = false
    },
    isDisabledInfo (target, value) {
    const list = this.content[target];
    if (!list || !value || !list.includes(value)) return false;

    if (value === 'phone' || value === 'email') {
      const hasPhone = list.includes('phone');
      const hasEmail = list.includes('email');
      
      // 둘 다 체크되어 있다면 하나는 해제 가능(false), 
      // 하나만 체크되어 있다면 그 하나는 해제 불가(true)
      // 커스텀필드와 관계없이 이메일,전화번호는 둘중 하나만 해제 가능 
      return !(hasPhone && hasEmail);
    }
    return false;
    },
    close () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    },
    apply () {
      const data = this.content
      if (window.confirm(this.locale.confirm_save)) {
        this.$emit('apply', data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.infoMessage {
  color: $color-grey;
}
.infoGroup {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 4px;
}
</style>
